import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=7774989e&scoped=true"
import script from "./OrderCreate.vue?vue&type=script&lang=js"
export * from "./OrderCreate.vue?vue&type=script&lang=js"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&id=7774989e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774989e",
  null
  
)

export default component.exports